import { Component, OnInit, Input } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { TypeCongesService } from "../../core/service/type-conges.service";
import { CongesService } from "../../core/service/conges.service";
import { EmployeeService } from "../../core/service/employee.service";
import { Conges } from "../../core/model/conges";
import { TypeConges } from "../../core/model/type-conges";
import { Employee } from "../../core/model/employee/employee";

@Component({
  selector: "app-add-conges",
  templateUrl: "./add-conges.component.html",
  styleUrls: ["./add-conges.component.scss"],
})
export class AddCongesComponent implements OnInit {
  @Input() annee;
  @Input() username;

  conge: Conges = new Conges();
  types: TypeConges[];
  employees: Employee[];

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _typeCongesService: TypeCongesService,
    private _congesService: CongesService,
    private _employeeService: EmployeeService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      typeConge: [null, Validators.compose([Validators.required])],
      dateDebut: [null, Validators.compose([Validators.required])],
      nbreJour: [null, Validators.compose([Validators.required])],
      backupUsername: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getAllTypeConges();
    this.getAllEmployees();
  }

  getAllTypeConges() {
    this._typeCongesService.getAll().subscribe(
      (data) => {
        this.types = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllEmployees() {
    this._employeeService.getAllEmployees().subscribe(
      (data) => {
        this.employees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.conge.dateDebut = this.convertDateJsonToDateString(
      this.form2.value.dateDebut,
      { hour: 1, minute: 1 }
    );
    this.conge.annee = this.annee;
    this.conge.userName = this.username;

    this.pressButton = true;
    this._congesService
      .addConge(this.conge)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  convertDateJsonToDateString(date, time) {
    let month;
    month = date.month;
    if (date.month < 10) {
      month = "0" + date.month;
    }

    let day;
    day = date.day;
    if (date.day < 10) {
      day = "0" + date.day;
    }

    //

    let hour;
    hour = time.hour;
    if (time.hour < 10) {
      hour = "0" + time.hour;
    }

    let minute;
    minute = time.minute;
    if (time.minute < 10) {
      minute = "0" + time.minute;
    }

    let datetime =
      date.year + "-" + month + "-" + day + "T" + hour + ":" + minute;
    return datetime;
  }

  convertDateStringToDateJson(date: string) {
    let dateSimple = new Date(date);
    let dateJson = {
      year: dateSimple.getFullYear(),
      month: dateSimple.getMonth() + 1,
      day: dateSimple.getDate(),
    };
    return dateJson;
  }
}
